// extracted by mini-css-extract-plugin
module.exports = {"main":"units_main__1lOXT","cntTabsResults":"units_cntTabsResults__3ICle"};